import Routes from './routes'
import ReducerFuncs from './store'

const Reducers = (reducerObj) => { reducerObj.facebook = ReducerFuncs }

export {
  Routes,
  Reducers
}
